import { getRunTime } from '../../tools/utils'
import { getPlatform } from '../../tools/getPlatform'

export default class ReportEntry {
  constructor({
    objectName,
    objectId,
    $toast = window.toast,
    $http, // 传入axios
    handleResponse = res => res
  }) {
    // 外部传入变量
    if (!objectName) {
      throw new Error('********* objectName必传！*********')
    }
    if (!$http) {
      throw new Error('********* $http必传！*********')
    }
    this.objectName = objectName // 目前需举报的类型：fm、 article
    this.objectId = objectId
    this.$toast = $toast
    this.$http = $http
    this.handleResponse = handleResponse

    // 内部变量
    this.popupId = 'yxl-article-report-popup'
    this.mHost = getRunTime('//m.xinli001.com')
    this.reportList = []
    this.currentItem = null
    this.pending = false
    this.objectMap = {
      fm: 'FM',
      article: '文章'
    }
    this.$platform = getPlatform()
  }

  start() {
    this.getReportList()
      .then(() => {
        return this.mountPopup()
      })
      .then(() => {
        this.$popup = document.querySelector(`#${this.popupId}`)
        this.listenEvents()
      })
      .catch(err => {
        console.log(err)
      })
  }

  getReportList() {
    const url = `${this.mHost}/qa/qa-api/get-report-config.json`
    return this.$http.get(url).then(res => {
      const { code, data } = this.handleResponse(res)
      if (code === 0) {
        this.reportList = data.config || []
      }
    })
  }

  mountPopup() {
    return new Promise(resolve => {
      const $tpl = this._getPopupTemplate()
      document.body.insertAdjacentHTML('beforeend', $tpl)
      setTimeout(() => {
        resolve()
      }, 50) // 延时进行事件监听、DOM操作
    })
  }

  listenEvents() {
    // 点击举报按钮
    const $reportBtn = document.querySelector('#yxl-article-report-btn')
    $reportBtn &&
      $reportBtn.addEventListener('click', () => {
        let isWechat = /MicroMessenger\/([\d/.]+)/i.test(navigator.userAgent)
        if (isWechat) return // 目前均不在微信中打开。
        this.$popup.style.display = 'block'
        this._toggleActiveStatus()
        this.currentItem = null
      })

    // 选择举报列表
    const $reportList = document.querySelector(`#${this.popupId} .report-list`)
    $reportList &&
      $reportList.addEventListener('click', e => {
        const target = e.target
        const $reportItem = this._getClosestAncestor(target, 'report-item')
        if ($reportItem) {
          let idx = +$reportItem.getAttribute('data-idx')
          if (!Number.isNaN(idx)) {
            this.currentItem = this.reportList[idx]
            this._toggleActiveStatus($reportItem)
          }
        }
      })

    // 点击关闭按钮
    const $closeBtn = document.querySelector(`#${this.popupId} .close-btn`)
    $closeBtn &&
      $closeBtn.addEventListener('click', () => {
        this.$popup.style.display = 'none'
      })

    // 点击举报弹窗中的确定
    const $confirmBtn = document.querySelector(`#${this.popupId} .confirm-btn`)
    $confirmBtn &&
      $confirmBtn.addEventListener('click', () => {
        this.confirmReport()
      })
  }

  confirmReport() {
    if (!this.currentItem) {
      return this.$toast('请先选择您要举报的原因~')
    }
    // 有些id不能一开始就获取，写成函数，按需索取
    const oid =
      typeof this.objectId === 'function' ? this.objectId() : this.objectId
    if (!oid) {
      return this.$toast(`${this.objectMap[this.objectName]}不存在`)
    }

    if (this.pending) return
    this.pending = true
    const url = `${this.mHost}/qa/qa-api/report-object.json`
    this.$http
      .post(url, {
        object_id: +oid,
        object_name: this.objectName,
        reason: +this.currentItem.key
      })
      .then(res => {
        const { code, message } = this.handleResponse(res)
        if (code === 0) {
          this.$toast('举报成功')
          setTimeout(() => {
            this.$popup.style.display = 'none'
          }, 1500)
        } else {
          this.$toast(message)
        }
        setTimeout(() => {
          this.pending = false
        }, 2000) // 等toast结束
      })
      .catch(err => {
        console.log(err)
        this.$toast('举报失败，请重试')
        setTimeout(() => {
          this.pending = false
        }, 2000) // 等toast结束
      })
  }

  // 举报弹窗模板
  _getPopupTemplate() {
    const { isPc } = this.$platform
    const closeImg = isPc
      ? require(`./images/report_entry_close_pc.png`)
      : require(`./images/report_entry_close_h5.png`)
    const bgImg = isPc ? '' : require(`./images/report_entry_bg_h5.png`)

    return `
      <div id="${this.popupId}" class="popup-wrp">
        <div class="popup-mask">
          <div class="popup-content" style="background-image: url(${bgImg})">
            <p class="popup-title">是否确认要举报ta呢？</p>
            <p class="popup-desc">有时能包容不同的观点和真实的反馈，<br>也是一种智慧</p>
            <ul class="report-list">
              ${this._getListTemplate()}
            </ul>
            <div class="popup-btn-list">
              <p class="confirm-btn">确认</p>
            </div>
            <div class="close-btn" style="background-image: url(${closeImg})"></div>
          </div>
        </div>
      </div>
    `
  }

  _getListTemplate() {
    let res = ``
    this.reportList.forEach((item, index) => {
      res += `
        <li class="report-item" data-idx="${index}">
          <p>${item.content}</p>
        </li>
      `
    })
    return res
  }

  _toggleActiveStatus(target) {
    let $reportItems = document.querySelectorAll(
      `#${this.popupId} .report-item`
    )
    if ($reportItems && $reportItems.length) {
      $reportItems = Array.from($reportItems)
      $reportItems.forEach(item => {
        item.classList.remove('active')
      })
      target && target.classList.add('active')
    }
  }

  _getClosestAncestor(el, selector) {
    if (!el || !selector) return null
    let p = el
    while (p) {
      if (p.classList.contains(selector)) {
        return p
      }
      p = p.parentElement
    }
    return null
  }
}



// WEBPACK FOOTER //
// ./src/frontend-lib/component/reportPopup/index.js